module.exports = __webpack_public_path__ + "static/backed_by_science-90ee4c903572119f6ac981c465a65b56.jpg";